var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookBarLocationRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BookBarLocation") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "book-bar-large",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-444.000000, -14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FF0036",
    id: "field-icons"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438.902872,8.77702074 L438,16 L437,16 L436.097128,8.77702074 C434.298789,8.18752294 433,6.49543574 433,4.5 C433,2.01471863 435.014719,0 437.5,0 C439.985281,0 442,2.01471863 442,4.5 C442,6.49543574 440.701211,8.18752294 438.902872,8.77702074 Z M438.5,5 C439.328427,5 440,4.32842712 440,3.5 C440,2.67157288 439.328427,2 438.5,2 C437.671573,2 437,2.67157288 437,3.5 C437,4.32842712 437.671573,5 438.5,5 Z",
    id: "BookBarLocation"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookBarLocationRed);
export default __webpack_public_path__ + "static/media/BookBarLocationRed.456afbda67227ce8fc1f86801ccc7de4.svg";
export { ForwardRef as ReactComponent };